import PropTypes from "prop-types";
import {useCallback, useContext, useEffect, useState} from "react";
import {AppDataContext} from "../../../App";
import UseApiManager from "../../../core/manager/api";
import MaplibreManager, {OverwriteMode} from "../../../core/manager/maplibre";


const SourceName = "road"

export const LayerName = {
    Polyline: {id: "road-polyline-layer", at: 0},
    Label: {id: "road-label-layer", at: 1},
}

const MapRoadLayer = ({map, style, visible, onInit}) => {

    const { state } = useContext(AppDataContext)
    const [url, setUrl] = useState()
    const { QueryVectorTileUrl } = UseApiManager()
    const { addLayer, addVectorSource, removes, setVisible, zoomInterpolate} = MaplibreManager()

    useEffect(() => {
        if (!map) { return }

        QueryVectorTileUrl(`
        SELECT the_geom_webmercator, route_name FROM ${state.env.CLIENT_ROAD_LINE_TABLE}
        `).then(setUrl)

    }, [map])

    useEffect(() => {
        if (!map || !url) { return }

        setTimeout(initLayer, 500)

        return () => {
            removes(map, {source: SourceName, layers: LayerName})
        }

    }, [map, url, style])

    const initLayer = useCallback(() => {
        if (!map || !url) { return }

        addVectorSource(map, SourceName, url, OverwriteMode.Rewrite)
        addLayer(map, {
            id: LayerName.Polyline.id,
            type: "line",
            source: SourceName,
            sourceLayer: "layer0",
            layout: {
                lineJoin: "round",
                lineCap: "round",
                visibility: visible ? "visible" : "none",
            },
            paint: {
                lineColor: "#a0a0a0a0",
                lineWidth: zoomInterpolate({8:1, 10:2, 14:3, 18:18}),
                lineOpacity: 0.8,
            }
        }, OverwriteMode.Rewrite)

        addLayer(map, {
            id: LayerName.Label.id,
            type: "symbol",
            source: SourceName,
            sourceLayer: "layer0",
            layout: {
                textField: ['get', 'route_name'], // 'road_number' は実際のデータのプロパティ名に置き換えてください
                textFont: ["MPLUS2-Regular"],
//                textSize: 12,
                textSize: zoomInterpolate({8:8, 10:10, 14:14, 18:16}),
                textJustify: 'center',
                textAnchor: 'center',
                textOffset: [0, -0.5], // テキストを上に移動。値を調整して最適な位置を見つけてください
                symbolPlacement: 'point', // 道路の中心に配置
                textRotationAlignment: 'viewport',
                textAllowOverlap: false,
                textIgnorePlacement: false,
                textPadding: 2,
                visibility: visible ? "visible" : "none",
            },
            paint: {
                textColor: '#000000',
                textHaloColor: '#ffffff',
                textHaloWidth: 2
            }
        }, OverwriteMode.Rewrite)

        setVisible(map, LayerName, visible)
        onInit && onInit()
    }, [map, url, visible, onInit])

    useEffect(() => {
        setVisible(map, LayerName, visible)
    }, [map, style, visible])

    return null
}

MapRoadLayer.propTypes = {
    map: PropTypes.any,
    visible: PropTypes.bool,
    style: PropTypes.string,
    onInit: PropTypes.func,
}

export default MapRoadLayer
